import Vue from 'vue'
import lodash from 'lodash'

// function parseSearchQuery(search) {
//   const properties = [
//     { name: 'name' },
//     { discord: 'discordId' },
//     { vehicle: 'VehicleId' },
//     { id: 'id' },
//     { type: 'type' },
//     { removeEmptyVehicles: 'removeEmptyVehicles' },
//   ]

//   const query = {}
//   let type
//   let removeEmptyVehicles

//   const searchQueries = search.split(' ')
//   searchQueries.forEach(searchQuery => {
//     if (searchQuery.includes(':')) {
//       const [key, value] = searchQuery.split(':')
//       properties.forEach(propertyMap => {
//         if (propertyMap[key]) {
//           if (key === 'type') {
//             type = value.trim()
//           } else if (key === 'removeEmptyVehicles') {
//             removeEmptyVehicles = value.trim() === 'true'
//           } else {
//             query[propertyMap[key]] = value.trim()
//           }
//         }
//       })
//     } else if (!query.name) {
//       query.name = searchQuery.trim()
//     }
//   })

//   return { query, type, removeEmptyVehicles }
// }

// function entitySearch(items, parserResult) {
//   const { query, type, modifiers } = parserResult
//   let filteredItems = items

//   // Apply filters based on the properties specified in the search query
//   Object.keys(query).forEach(property => {
//     filteredItems = filteredItems.filter(
//       item => item[property] && item[property].toString().toLowerCase().includes(query[property].trim()),
//     )
//   })

//   if (type === 'employee') {
//     return filteredItems
//   }

//   if (type === 'vehicle') {
//     // Filter vehicles by the employees inside
//     filteredItems = filteredItems.filter(vehicle => {
//       let hasMatchingEmployee = false
//       vehicle.Employees.forEach(employee => {
//         Object.keys(query).forEach(property => {
//           if (employee[property] && employee[property].toString().toLowerCase().includes(query[property].trim())) {
//             hasMatchingEmployee = true
//           }
//         })
//       })
//       return hasMatchingEmployee
//     })

//     // Remove vehicles with no matching employees if the "removeEmptyVehicles" modifier is set
//     if (modifiers && modifiers.removeEmptyVehicles) {
//       filteredItems = filteredItems.filter(vehicle => vehicle.Employees.length > 0)
//     }
//     return filteredItems
//   }

//   // Handle other types of entities here if needed
//   return filteredItems
// }

function employeeSearch(items, search) {
  return items.filter(
    item =>
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.discordId.toLowerCase().includes(search.toLowerCase()),
  )
}

function vehicleSearch(items, search) {
  return items.map(item => ({
    ...item,
    Employees: employeeSearch(item.Employees, search),
  }))
}

function callCardSearch(items, search) {
  return items.map(item => ({
    ...item,
    Vehicles:
      search.trim() === ''
        ? item.Vehicles
        : item.Vehicles.filter(vehicle => employeeSearch(vehicle.Employees, search).length > 0),
  }))
}

export default {
  namespaced: true,
  state: {
    search: '',
    onDuty: [],
    offDuty: [],
    vehicles: [],
    callCards: [],
    statuses: [],
    sectors: [],
  },
  getters: {
    onDutyNotInVehicles: (state, getters) => getters.filteredOnDuty.filter(onDuty => onDuty.VehicleId === null),
    vehiclesNotInCalls: (state, getters) => {
      if (getters.isSearchEmpty) {
        return getters.filteredVehicles.filter(vh => vh.CallId === null)
      }

      return getters.filteredVehicles.filter(vh => vh.Employees.length > 0 && vh.CallId === null)
    },
    isSearchEmpty: state => state.search.trim() === '',
    filteredOnDuty: state => employeeSearch(state.onDuty, state.search),
    filteredOffDuty: state => employeeSearch(state.offDuty, state.search),
    filteredVehicles: state => vehicleSearch(state.vehicles, state.search),
    filteredCallCards: state => callCardSearch(state.callCards, state.search),
  },
  mutations: {
    setSearch(state, search) {
      state.search = search
    },
    addOnDuty(state, { employee, index }) {
      const existing = state.onDuty.find(onDuty => onDuty.discordId === employee.discordId)

      // Forces an employee to have a VehicleId
      if (!employee.VehicleId) {
        // eslint-disable-next-line no-param-reassign
        employee.VehicleId = null
      }

      if (!existing) {
        if (index >= 0) {
          state.onDuty.splice(index, 0, employee)
        } else {
          state.onDuty.push(employee)
        }
      }
    },
    removeOnDuty(state, employee) {
      const index = state.onDuty.findIndex(onDuty => onDuty.discordId === employee.discordId)
      if (index === -1) return

      state.onDuty.splice(index, 1)

      // TODO: remove from vehicles with commit
      state.vehicles.forEach(vehicle => {
        const lookup = lodash.keyBy(state.onDuty, 'id')
        // eslint-disable-next-line no-param-reassign
        vehicle.Employees = lodash.filter(vehicle.Employees, x => lookup[x.id] !== undefined)
      })
    },
    setOnDuty(state, onDuty) {
      state.onDuty = onDuty
    },
    addOffDuty(state, { employee, index }) {
      const existing = state.offDuty.find(offDuty => offDuty.discordId === employee.discordId)
      if (!existing) {
        if (index >= 0) {
          state.offDuty.splice(index, 0, employee)
        } else {
          state.offDuty.push(employee)
        }
      }
    },
    removeOffDuty(state, employee) {
      const index = state.offDuty.findIndex(offDuty => offDuty.discordId === employee.discordId)
      if (index > -1) {
        state.offDuty.splice(index, 1)
      }
    },
    setOffDuty(state, offDuty) {
      state.offDuty = offDuty
    },
    setVehicles(state, vehicles) {
      state.vehicles = vehicles
    },
    addVehicle(state, { vehicle }) {
      state.vehicles.push(vehicle)
    },
    updateVehicle(state, { vehicleId, vehicle }) {
      const vehicleIndex = state.vehicles.findIndex(x => x.id === vehicleId)

      state.vehicles[vehicleIndex].name = vehicle.name
      state.vehicles[vehicleIndex].Sector = vehicle.Sector
      state.vehicles[vehicleIndex].Status = vehicle.Status
      state.vehicles[vehicleIndex].updatedAt = vehicle.updatedAt
    },
    deleteVehicle(state, { vehicleId }) {
      const vehicleIndex = state.vehicles.findIndex(x => x.id === vehicleId)
      const employees = state.vehicles[vehicleIndex].Employees
      const callCardId = state.vehicles[vehicleIndex].CallId

      employees.forEach(employee => {
        const employeeIndex = state.onDuty.findIndex(onDuty => onDuty.discordId === employee.discordId)
        if (employeeIndex > -1) {
          state.onDuty[employeeIndex].VehicleId = null
        }
      })

      if (callCardId) {
        const callCardIndex = state.callCards.findIndex(x => x.id === callCardId)
        const vehicleIndexInCall = state.callCards[callCardIndex].Vehicles.findIndex(x => x.id === vehicleId)
        state.callCards[callCardIndex].Vehicles.splice(vehicleIndexInCall, 1)
      }

      state.vehicles.splice(vehicleIndex, 1)
    },
    assignToVehicle(state, { employee, vehicleId, oldVehicleId, addedIndex }) {
      const vehicleIndex = state.vehicles.findIndex(vh => vh.id === vehicleId)
      const vehicle = state.vehicles[vehicleIndex]
      if (!vehicle) {
        return
      }

      if (addedIndex >= 0) {
        vehicle.Employees.splice(addedIndex, 0, employee)
      } else {
        vehicle.Employees.push(employee)
      }

      if (oldVehicleId > 0) {
        const oldVehicle = state.vehicles.find(vh => vh.id === oldVehicleId)
        if (oldVehicle) {
          const employeeIndex = oldVehicle.Employees.findIndex(emp => emp.id === employee.id)
          if (employeeIndex > -1) {
            oldVehicle.Employees.splice(employeeIndex, 1)
          }
        }
      }

      const employeeIndex = state.onDuty.findIndex(onDuty => onDuty.discordId === employee.discordId)
      if (employeeIndex > -1) {
        state.onDuty[employeeIndex].VehicleId = vehicleId
      }
    },
    unassignOfVehicle(state, { employee, vehicleId }) {
      const existing = state.onDuty.find(onDuty => onDuty.discordId === employee.discordId)
      if (existing) {
        existing.VehicleId = null
      }

      const vehicleIndex = state.vehicles.findIndex(x => x.id === vehicleId)
      if (vehicleIndex > -1) {
        const employeeIndex = state.vehicles[vehicleIndex].Employees.findIndex(x => x.id === employee.id)
        if (employeeIndex > -1) {
          state.vehicles[vehicleIndex].Employees.splice(employeeIndex, 1)
        }
      }
    },
    addCallCard(state, { callCard }) {
      state.callCards.push(callCard)
    },
    setCallCards(state, callCards) {
      state.callCards = callCards
    },
    updateCallCard(state, { callCardId, callCard }) {
      const callCardIndex = state.callCards.findIndex(x => x.id === callCardId)

      state.callCards[callCardIndex].title = callCard.title
      state.callCards[callCardIndex].description = callCard.description
      state.callCards[callCardIndex].location = callCard.location
    },
    deleteCallCard(state, { callCardId }) {
      const callCardIndex = state.callCards.findIndex(x => x.id === callCardId)
      const vehicles = state.callCards[callCardIndex].Vehicles

      vehicles.forEach(vehicle => {
        const vehicleIndex = state.vehicles.findIndex(vh => vh.id === vehicle.id)
        if (vehicleIndex > -1) {
          state.vehicles[vehicleIndex].CallId = null
        }
      })

      state.callCards.splice(callCardIndex, 1)
    },
    assignToCall(state, { vehicle, callId, oldCallId, addedIndex }) {
      const callCard = state.callCards.find(call => call.id === callId)
      if (!callCard) {
        return
      }

      if (addedIndex >= 0) {
        callCard.Vehicles.splice(addedIndex, 0, vehicle)
      } else {
        callCard.Vehicles.push(vehicle)
      }

      if (oldCallId > 0) {
        const oldCall = state.callCards.find(call => call.id === oldCallId)
        if (oldCall) {
          const vehicleIndex = oldCall.Vehicles.findIndex(vh => vh.id === vehicle.id)
          if (vehicleIndex > -1) {
            oldCall.Vehicles.splice(vehicleIndex, 1)
          }
        }
      }

      const vehicleIndex = state.vehicles.findIndex(vh => vh.id === vehicle.id)
      if (vehicleIndex > -1) {
        state.vehicles[vehicleIndex].CallId = callId
      }
    },
    unassignOfCall(state, { vehicle, callId }) {
      const existing = state.vehicles.find(vh => vh.id === vehicle.id)
      if (existing) {
        existing.CallId = null
      }

      const callIndex = state.callCards.findIndex(x => x.id === callId)
      if (callIndex > -1) {
        const vehicleIndex = state.callCards[callIndex].Vehicles.findIndex(x => x.id === vehicle.id)
        if (vehicleIndex > -1) {
          state.callCards[callIndex].Vehicles.splice(vehicleIndex, 1)
        }
      }
    },
    // Should be use internally of this store to update the call card vehicle after the vehicle is updated
    updateCallCardVehicle(state, { vehicleId }) {
      const vehicle = state.vehicles.find(vh => vh.id === vehicleId)
      if (vehicle) {
        const callId = vehicle.CallId

        if (callId) {
          const callCard = state.callCards.find(call => call.id === callId)
          if (callCard) {
            const vehicleIndexInCall = callCard.Vehicles.findIndex(x => x.id === vehicle.id)
            if (vehicleIndexInCall > -1) {
              Vue.set(callCard.Vehicles, vehicleIndexInCall, vehicle)
            }
          }
        }
      }
    },
    // STATUS AND SECTOR
    setStatuses(state, statuses) {
      state.statuses = statuses
    },
    setSectors(state, sectors) {
      state.sectors = sectors
    },
  },
  actions: {
    UPDATE_SEARCH: ({ commit }, search) => commit('setSearch', search),
    GET_ON_DUTY: ({ rootState, commit }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/onDuty`)
          .then(res => {
            commit('setOnDuty', res.data)
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    SET_ON_DUTY: ({ rootState }, { employee, index }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/onDuty/set/${employee.discordId}?index=${index}`,
            {
              reason: 'CAD',
            },
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_OFF_DUTY: ({ rootState, commit }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/offDuty`)
          .then(res => {
            commit('setOffDuty', res.data)
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    SET_OFF_DUTY: ({ rootState }, { employee, index }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/offDuty/set/${employee.discordId}?index=${index}`,
            {
              reason: 'CAD',
            },
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    SOCKET_NEW_ON_DUTY: ({ commit }, { onDuty, index }) => {
      commit('addOnDuty', { employee: onDuty, index })
      commit('removeOffDuty', onDuty)
    },
    SOCKET_REMOVE_ON_DUTY: ({ commit }, { onDuty, index }) => {
      commit('addOffDuty', { employee: onDuty, index })
      commit('removeOnDuty', onDuty)
    },
    SOCKET_REMOVE_MEMBER: ({ commit }, { employee }) => {
      commit('removeOffDuty', employee)
      commit('removeOnDuty', employee)
    },
    // VEHICLES
    GET_VEHICLES: ({ rootState, commit }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/vehicles`,
          )
          .then(res => {
            commit('setVehicles', res.data)
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    ADD_VEHICLE: ({ rootState }, vehicle) =>
      new Promise((resolve, reject) => {
        const payload = {
          name: vehicle.name,
          sectorId: vehicle.Sector.id,
          statusId: vehicle.Status.id,
        }

        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/vehicles`,
            payload,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_VEHICLE: ({ rootState }, { vehicle, nameOnly }) =>
      new Promise((resolve, reject) => {
        const payload = {
          name: vehicle.name,
        }
        if (!nameOnly) {
          payload.sectorId = vehicle.Sector.id
          payload.statusId = vehicle.Status.id
        }

        Vue.prototype.$http
          .put(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/vehicles/${vehicle.id}`,
            payload,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_VEHICLE: ({ rootState }, { vehicle }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/vehicles/${vehicle.id}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    ASSIGN_TO_VEHICLE: ({ rootState }, { vehicle, employee, index }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/vehicles/${vehicle.id}/assign`,
            {
              employeeId: employee.discordId,
              indexInVehicle: index,
            },
          )
          .then(res => {
            // commit('assignToVehicle', { vehicle: res.data, employee })
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UNASSIGN_OF_VEHICLE: ({ rootState }, { vehicle, employee }) =>
      new Promise((resolve, reject) => {
        let vehicleId = null
        if (vehicle) {
          vehicleId = vehicle.id
        } else {
          vehicleId = employee.VehicleId
        }

        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/vehicles/${vehicleId}/unassign`,
            {
              employeeId: employee.discordId,
            },
          )
          .then(res => {
            // commit('unassignOfVehicle', { vehicle: res.data, employee })
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_VEHICLES({ commit }, vehicles) {
      commit('setVehicles', vehicles)
    },
    SOCKET_ASSIGNED_TO_VEHICLE: ({ commit }, { vehicleId, oldVehicleId, employee, index }) => {
      commit('assignToVehicle', { vehicleId, oldVehicleId, employee, addedIndex: index })
      commit('updateCallCardVehicle', { vehicleId })
    },
    SOCKET_UNASSIGNED_OF_VEHICLE: ({ commit }, { vehicleId, employee }) => {
      commit('unassignOfVehicle', { vehicleId, employee })
      commit('updateCallCardVehicle', { vehicleId })
    },
    SOCKET_VEHICLE_CREATED: ({ commit }, { vehicle }) => {
      commit('addVehicle', { vehicle })
    },
    SOCKET_VEHICLE_UPDATED: ({ commit }, { vehicle, vehicleId }) => {
      commit('updateVehicle', { vehicle, vehicleId })
      commit('updateCallCardVehicle', { vehicleId })
    },
    SOCKET_VEHICLE_DELETED: ({ commit }, { vehicleId }) => {
      commit('deleteVehicle', { vehicleId })
    },
    // CALL CARDS
    GET_CALLS: ({ rootState, commit }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/calls`)
          .then(res => {
            commit('setCallCards', res.data)
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    ADD_CALL: ({ rootState }, callCard) =>
      new Promise((resolve, reject) => {
        const payload = {
          title: callCard.title,
          description: callCard.description,
        }

        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/calls`,
            payload,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UPDATE_CALL: ({ rootState }, { callCard }) =>
      new Promise((resolve, reject) => {
        const payload = {
          title: callCard.title,
          location: callCard.location,
          description: callCard.description,
        }

        Vue.prototype.$http
          .put(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/calls/${callCard.id}`,
            payload,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    DELETE_CALL: ({ rootState }, { callCard }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .delete(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/calls/${callCard.id}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    ASSIGN_TO_CALL: ({ rootState }, { callCard, vehicle, index }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/calls/${callCard.id}/assign`,
            {
              vehicleId: vehicle.id,
              indexInCall: index,
            },
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    UNASSIGN_OF_CALL: ({ rootState }, { callCard, vehicle }) =>
      new Promise((resolve, reject) => {
        let callCardId = null
        if (callCard) {
          callCardId = callCard.id
        } else {
          callCardId = vehicle.CallId
        }

        Vue.prototype.$http
          .post(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/calls/${callCardId}/unassign`,
            {
              vehicleId: vehicle.id,
            },
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    SOCKET_CALL_CREATED: ({ commit }, { call }) => {
      commit('addCallCard', { callCard: call })
    },
    SOCKET_CALL_UPDATED: ({ commit }, { call, callId }) => {
      commit('updateCallCard', { callCard: call, callCardId: callId })
    },
    SOCKET_CALL_DELETED: ({ commit }, { callId }) => {
      commit('deleteCallCard', { callCardId: callId })
    },
    SOCKET_ASSIGNED_TO_CALL: ({ commit }, { callId, oldCallId, vehicle, index }) => {
      commit('assignToCall', { callId, oldCallId, vehicle, addedIndex: index })
    },
    SOCKET_UNASSIGNED_OF_CALL: ({ commit }, { callId, vehicle }) => {
      commit('unassignOfCall', { callId, vehicle })
    },
    // UPDATE_CALL_CARDS({ commit }, callCards) {
    //   commit('updateCallCards', callCards)
    // },
    // STATUSES & SECTORS
    GET_STATUSES: ({ rootState, commit }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/statuses`,
          )
          .then(res => {
            commit('setStatuses', res.data)
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_SECTORS: ({ rootState, commit }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/sectors`)
          .then(res => {
            commit('setSectors', res.data)
            resolve(res)
          })
          .catch(err => reject(err))
      }),
  },
}
